import $ from 'jquery'
import slick from 'slick-slider'
import lazy from './lazyLoad';
import respImg from './responsiveImages';

const initImageSliders = function() {

    var sliders = $('[data-image-slider]');
    sliders.on('init',function() {
        preloadImages( $(this) );
    }).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        arrows: true,
        lazyLoad: false,
        adaptiveHeight: true,
        prevArrow: "<span class='compact dark' rel='prev'><i class='fas fa-arrow-left'></i></span>",
        nextArrow: "<span class='compact dark' rel='next'><i class='fas fa-arrow-right'></i></span>",
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                }
            }
        ]
    });

}

const initHeaderSliders = function() {

    $('.header-slider').each(function() {
        var el = $(this);
        var imgSliderEl = el.find('.header-slider__images dl');
        var textSliderEl = el.find('.header-slider__texts dl');
        var speed = el.data('speed');
        var track, bg;
        var style = el.get(0).style;

        var setBg = function(delay) {
            delay = delay ? 400 : 0;
            var h = imgSliderEl.outerHeight();
            var angle = 10 * Math.PI / 180;
            var edge = Math.atan(angle) * h;
            style.setProperty('--edge',Math.round(edge) + 'px');
            var activeImage = el.find('.slick-slide.slick-active .header-slider__image');
            var activeSlide = el.find('.slick-slide.slick-active');
            el.find('.slick-slide').removeClass('next-slide prev-slide');
            activeSlide.prev().addClass('prev-slide');
            activeSlide.next().addClass('next-slide');
            if(activeImage.hasClass('hide')) return;
            if(bg)bg.remove();
            bg = activeImage.clone();
            bg.prependTo( imgSliderEl );

            setTimeout(function() {
                activeImage.addClass('hide');
                el.find('.slick-slide:not(.slick-active) figure').removeClass('hide');
                bg.addClass('show');
            },delay);
        };

        textSliderEl.slick({
            slidesToShow:1,
            slidesToScroll: 1,
            fade: true,
            infinite: true,
            dots: false,
            arrows: false,
            draggable: false,
            adaptiveHeight: true,
        });

        imgSliderEl.on('init',function() {
            setBg();
        }).on('afterChange',function() {
            setBg(true);
        })

        imgSliderEl.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            asNavFor: textSliderEl,
            autoplay: speed ? true : false,
            autoplaySpeed: speed ? speed * 1000 : 0,
            speed: 1000,
            swipeToSlide: false,
        });
    });

}

const initProductsSliders = function() {

    var config = {
        1099: 4,
        767: 3,
        539: 2,
        319: 1,
    };

    var responsive = [];

    for(var n in config) {
        responsive.unshift( {
            breakpoint: n,
            settings: {
                slidesToShow: config[n],
            }
        } );
    }

    var sliders = $('[data-products-slider]');
    sliders.on('init',function() {
        preloadImages( $(this ) );
    }).slick({
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: false,
        dots: true,
        arrows: true,
        lazyLoad: false,
        adaptiveHeight: false,
        swipeToSlide: true,
        variableWidth: false,
        prevArrow: "<span class='compact' rel='prev'><i class='fas fa-arrow-left'></i></span>",
        nextArrow: "<span class='compact' rel='next'><i class='fas fa-arrow-right'></i></span>",
        responsive: responsive
    });

};

const initBlocksSliders = function() {

    var config = {
        1099: 4,
        767: 3,
        539: 2,
        319: 1,
    };

    var responsive = [];

    for(var n in config) {
        responsive.unshift( {
            breakpoint: n,
            settings: {
                slidesToShow: config[n]
            }
        } );
    }

    var sliders = $('[data-blocks-slider]');
    sliders.on('init',function() {
        preloadImages( $(this ) );
    }).slick({
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: false,
        dots: true,
        arrows: true,
        lazyLoad: false,
        adaptiveHeight: false,
        prevArrow: "<span class='compact dark' rel='prev'><i class='fas fa-arrow-left'></i></span>",
        nextArrow: "<span class='compact dark' rel='next'><i class='fas fa-arrow-right'></i></span>",
        swipeToSlide: true,
        responsive: responsive
    });
}

function preloadImages(slider,numSlides) {

    var slide = slider.find('.slick-slide.slick-active').lazyLoad();
    if(!numSlides) {
        //preload all
        slide.siblings().lazyLoad();
    } else {
        slide.prevAll().slice(-numSlides).lazyLoad();
        slide.nextAll().slice(0, numSlides).lazyLoad();
    }
}

export default {
    init: function() {
        initImageSliders();
        initBlocksSliders();
        initProductsSliders();
        initHeaderSliders();
    },
    initPreload: function(slider,numSlides) {
        slider.on('init',function() {
            respImg.initEl(slider,true);
            preloadImages(slider,numSlides);
        }).on('afterChange',function() {
            preloadImages(slider,numSlides);
        });
    },
    preload: function(slider,numSlides) {
        preloadImages(slider,numSlides || 0);
    },
};
